module.exports = __webpack_public_path__ + "img/sello.9865f8bb.svg";